import {
  BottomNavigationAction,
  BottomNavigationActionProps,
  Tab,
  TabProps,
} from "@mui/material";
import { usePrpNavigation } from "./PrpNavigationContext";
import { Location, useLocation } from "react-router-dom";
import { useEffect } from "react";

export interface PrpNavigationItemType {
  path?: string;
  action?: () => void;
  isSelectedCheck?: (location: Location) => boolean;
  label: React.ReactNode;
  icon?: React.ReactElement;
  position?: number;
}

export const PrpNavigationItem = ({
  item,
  bottomNavigationActionProps,
  tabProps,
}: {
  item: PrpNavigationItemType;
  bottomNavigationActionProps?: BottomNavigationActionProps;
  tabProps?: TabProps;
}) => {
  const location = useLocation();
  const { handleNavChange, isMobile, setSelected } = usePrpNavigation();
  const selectedSetting = item.isSelectedCheck
    ? item.isSelectedCheck(location)
    : item.path
      ? location.pathname.startsWith(item.path)
      : false;

  useEffect(() => {
    typeof item.position === "number" &&
      setSelected((selected) => {
        if (
          typeof item.position === "number" &&
          selected[item.position] !== selectedSetting
        ) {
          const newSelected = [...selected];
          newSelected[item.position] = selectedSetting;
          return newSelected;
        }
        return selected;
      });
  }, [item.position, location, selectedSetting, item.isSelectedCheck]);

  if (isMobile) {
    return (
      <BottomNavigationAction
        className={selectedSetting ? "Mui-selected" : ""}
        showLabel={true}
        value={item.position}
        label={item.label}
        icon={item.icon}
        onClick={() => handleNavChange(item)}
        {...bottomNavigationActionProps}
      />
    );
  }
  return (
    <Tab
      value={item.position}
      icon={item.icon}
      label={item.label}
      onClick={() => handleNavChange(item)}
      {...tabProps}
    />
  );
};
